import { render, staticRenderFns } from "./MagneticMirrorViz.vue?vue&type=template&id=f16077c0&scoped=true"
import script from "./MagneticMirrorViz.vue?vue&type=script&lang=js"
export * from "./MagneticMirrorViz.vue?vue&type=script&lang=js"
import style0 from "./MagneticMirrorViz.vue?vue&type=style&index=0&id=f16077c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16077c0",
  null
  
)

export default component.exports